import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { VarietyService } from '../../../service/variety.service';
import { getCurrentUserId } from '../../../shared/utils/auth-user.util';
import { TransactionAccessService } from '../../../shared/services/transaction-access.service';

@Component({
  selector: 'app-modal-delete-variety',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-delete-variety.html',
  styleUrl: './modal-delete-variety.scss'
})
export class ModalDeleteVariety implements OnInit {
  private varietyService = inject(VarietyService);
  private transactionAccess = inject(TransactionAccessService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  loading = signal(false);
  success = signal(false);
  error = signal<string | null>(null);
  codigo = 0;

  ngOnInit(): void {
    // Obtener el parámetro de la URL (ej: /delete-variety/123)
    this.codigo = Number(this.route.snapshot.paramMap.get('codigo'));
  }

  onConfirmDelete(): void {
    if (!this.codigo) return;

    this.loading.set(true);
    const transactionId = this.transactionAccess.getTransactionId('varieties');
    if (!transactionId) {
      this.error.set(
        'No se encontró la transacción de mantenimiento de variedades asignada al usuario.'
      );
      this.loading.set(false);
      return;
    }

    this.varietyService.delete(this.codigo, getCurrentUserId(), transactionId).subscribe({
      next: () => {
        this.loading.set(false);
        this.success.set(true);
      },
      error: () => {
        this.loading.set(false);
        this.error.set('Error al eliminar la variedad.');
      }
    });
  }

  onCancel(): void {
    this.router.navigate(['/search-variety']);
  }
}
